import React, { useState } from 'react';
import axios from 'axios';
import { UserCircle, Lock, Eye, EyeSlash, FloppyDisk } from '@phosphor-icons/react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const ProfileSection = ({ user, setUser, profileForm, setProfileForm }) => {
  const [passwordForm, setPasswordForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [showCurrentPwd, setShowCurrentPwd] = useState(false);
  const [showNewPwd, setShowNewPwd] = useState(false);
  const [savingProfile, setSavingProfile] = useState(false);

  const handleSaveProfile = async () => {
    if (passwordForm.new_password && passwordForm.new_password !== passwordForm.confirm_password) {
      toast.error('Les mots de passe ne correspondent pas');
      return;
    }
    setSavingProfile(true);
    try {
      const body = { name: profileForm.name, email: profileForm.email };
      if (passwordForm.current_password && passwordForm.new_password) {
        body.current_password = passwordForm.current_password;
        body.new_password = passwordForm.new_password;
      }
      const response = await axios.put(`${API_URL}/api/auth/profile`, body, { withCredentials: true });
      if (response.data.id) setUser(response.data);
      toast.success('Profil mis a jour');
      setPasswordForm({ current_password: '', new_password: '', confirm_password: '' });
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur mise a jour profil');
    } finally {
      setSavingProfile(false);
    }
  };

  return (
    <div className="card" data-testid="profile-section">
      <div className="card-header">
        <h3 className="card-title" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <UserCircle size={22} weight="bold" /> Mon profil
        </h3>
      </div>
      <div className="card-body">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label className="form-label">Nom</label>
            <input data-testid="profile-name-input" type="text" className="form-input" value={profileForm.name} onChange={(e) => setProfileForm(p => ({ ...p, name: e.target.value }))} />
          </div>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label className="form-label">Email</label>
            <input data-testid="profile-email-input" type="email" className="form-input" value={profileForm.email} onChange={(e) => setProfileForm(p => ({ ...p, email: e.target.value }))} />
          </div>
        </div>
        <div style={{ borderTop: '1px solid #E2E2E6', paddingTop: '16px' }}>
          <h4 style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.9rem', fontWeight: '700', marginBottom: '12px', color: '#5E5F66' }}>
            <Lock size={16} /> Changer le mot de passe
          </h4>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
            <div className="form-group" style={{ marginBottom: 0, position: 'relative' }}>
              <label className="form-label">Mot de passe actuel</label>
              <div style={{ position: 'relative' }}>
                <input data-testid="profile-current-pwd" type={showCurrentPwd ? 'text' : 'password'} className="form-input" value={passwordForm.current_password} onChange={(e) => setPasswordForm(p => ({ ...p, current_password: e.target.value }))} placeholder="Actuel" />
                <button type="button" onClick={() => setShowCurrentPwd(!showCurrentPwd)} style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#5E5F66' }}>{showCurrentPwd ? <EyeSlash size={16} /> : <Eye size={16} />}</button>
              </div>
            </div>
            <div className="form-group" style={{ marginBottom: 0, position: 'relative' }}>
              <label className="form-label">Nouveau mot de passe</label>
              <div style={{ position: 'relative' }}>
                <input data-testid="profile-new-pwd" type={showNewPwd ? 'text' : 'password'} className="form-input" value={passwordForm.new_password} onChange={(e) => setPasswordForm(p => ({ ...p, new_password: e.target.value }))} placeholder="Nouveau" />
                <button type="button" onClick={() => setShowNewPwd(!showNewPwd)} style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#5E5F66' }}>{showNewPwd ? <EyeSlash size={16} /> : <Eye size={16} />}</button>
              </div>
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="form-label">Confirmer</label>
              <input data-testid="profile-confirm-pwd" type="password" className="form-input" value={passwordForm.confirm_password} onChange={(e) => setPasswordForm(p => ({ ...p, confirm_password: e.target.value }))} placeholder="Confirmer" />
            </div>
          </div>
        </div>
        <button data-testid="save-profile-btn" className="btn btn-primary" onClick={handleSaveProfile} disabled={savingProfile} style={{ marginTop: '16px' }}>
          <FloppyDisk size={16} /> {savingProfile ? 'Enregistrement...' : 'Enregistrer le profil'}
        </button>
      </div>
    </div>
  );
};
